import React, { PropTypes } from 'react';

import LoadingSpinner from '../../../shared/js/components/LoadingSpinner';

import { sortBy } from 'lodash';
import { propertyHasChanged } from '../lib/objectComparison';

import '../../styles/SelectGlobalThing';

class SelectGlobalDistrict extends React.Component {

	componentWillMount() {
		// If a list of districts already exists in state, don't bother to re-fetch
		if (this.props.districts && this.props.districts.length) {
			// If no district is selected in the props, but one is saved in localStorage, select it
			if (localStorage.getItem('district') && !this.props.selectedDistrict) {
				this.restoreDistrictFromLocalStorage();
			}
		} else {
			this.props.fetchDistricts().then(this.restoreDistrictFromLocalStorage.bind(this));
		}
	}

	componentDidMount() {
		this.initializeDropdown();
	}

	componentWillReceiveProps(newProps) {
		if (this.props.selectedDistrict && propertyHasChanged(this.props.selectedDistrict, newProps.selectedDistrict)) {
			this.props.selectSchool(null);
			this.props.selectClassroom(null);
			this.props.selectStudent(null);
		}
	}

	componentDidUpdate() {
		this.initializeDropdown();
	}

	initializeDropdown() {
		$('.select-global-thing.select-global-district .ui.dropdown').dropdown({
			action: 'hide',
			onChange: this.selectDistrictById.bind(this),
			placeholder: 'Select district'
		});

		if (this.props.selectedDistrict) {
			$('.select-global-district .ui.dropdown').dropdown('set selected', this.props.selectedDistrict.id);
		} else {
			$('.select-global-district .ui.dropdown').dropdown('clear');
		}
	}

	restoreDistrictFromLocalStorage() {
		const selectedDistrictId = localStorage.getItem('district');

		if (selectedDistrictId) {
			this.selectDistrictById(selectedDistrictId);
		}
	}

	selectDistrictById(districtId) {
		let isNewDistrict = !this.props.selectedDistrict || (this.props.selectedDistrict.id.toString() !== districtId.toString());

		if (this.props.districts && isNewDistrict) {
			this.props.districts.every((district) => {
				if (district.id.toString() === districtId.toString()) {
					this.props.selectDistrict(district);
					return false;
				} else {
					return true;
				}
			});
		}
	}

	isDisabled() {
		return this.props.isFetchingDistricts || this.props.disabled;
	}

	render() {
		return (
			<div className="select-global-thing select-global-district">
				<div className={ `ui floating dropdown labeled search icon button fluid${ this.isDisabled() ? ' disabled' : '' }` }>
					<i />
					<div className="icon-left">D</div>
					<div className="default text">Select district</div>
					<div className="menu">
						{
							this.props.districts ? (
								sortBy(this.props.districts, 'name').map((district) => {
									return (
										<div
											className="item"
											data-value={ district.id }
											key={ `select-global-district-option-${ district.id }` }
										>
											{ district.name }
										</div>
									);
								})
							) : ''
						}
					</div>
					<div className="icon-right">
						{
							this.props.isFetching ? (
								<LoadingSpinner />
							) : (
								<i className="fas fa-caret-down" />
							)
						}
					</div>
				</div>
			</div>
		);
	}
}

SelectGlobalDistrict.propTypes = {
	disabled: PropTypes.bool,
	districts: PropTypes.array,
	fetchDistricts: PropTypes.func.isRequired,
	isFetching: PropTypes.bool,
	isFetchingDistricts: PropTypes.bool,
	selectClassroom: PropTypes.func.isRequired,
	selectDistrict: PropTypes.func.isRequired,
	selectedDistrict: PropTypes.object,
	selectSchool: PropTypes.func.isRequired,
	selectStudent: PropTypes.func
};

SelectGlobalDistrict.displayName = 'SelectGlobalDistrict';

export default SelectGlobalDistrict;



// WEBPACK FOOTER //
// ./frontend/a2i/js/components/SelectGlobalDistrict.jsx